const updateItems = [
  {
    time: '10分钟前',
    tag: '娱乐圈',
    title: '顶流艺人深夜发布声明回应近期争议，全文态度强硬否认全部指控',
  },
  {
    time: '28分钟前',
    tag: '综艺',
    title: '热门综艺录制现场突发状况，节目组紧急叫停并发布致歉公告',
  },
  {
    time: '1小时前',
    tag: '网红',
    title: '千万粉丝网红直播中口误爆料同行隐私，直播间瞬间被举报封禁',
  },
  {
    time: '2小时前',
    tag: '影视',
    title: '暑期档黑马电影票房逆袭破十亿，导演接受专访讲述幕后故事',
  },
  {
    time: '3小时前',
    tag: '热点',
    title: '社会热议事件最新进展：相关部门已介入调查并发布初步通报',
  },
  {
    time: '4小时前',
    tag: '体育',
    title: '知名运动员赛后采访言论引发争议，体育界多位前辈出面回应',
  },
  {
    time: '5小时前',
    tag: '国际',
    title: '好莱坞年度大片首映礼红毯造型引发全球网友热议和模仿潮',
  },
  {
    time: '6小时前',
    tag: '娱乐圈',
    title: '多对明星夫妻被拍同框出游，网友纷纷猜测感情状况新变化',
  },
  {
    time: '8小时前',
    tag: '直播',
    title: '头部带货主播团队内部矛盾曝光，核心成员集体离职引发震动',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            最新快讯
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            实时追踪全网最新吃瓜动态，重大事件第一时间为你呈现
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-200/70"></div>

          <div className="space-y-4 md:space-y-5">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12">
                <div className="absolute left-[15px] md:left-[19px] top-2 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>

                <div className="flex-1 bg-background-100 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200/70 transition-all cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="inline-block px-2 py-0.5 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 leading-relaxed hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}